import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthGuard, useSupabaseSession } from '@ubus/shared';

import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import TodayTasks from './pages/TodayTasks';
import TaskDetail from './pages/TaskDetail';
import PreTripInspection from './pages/PreTripInspection';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import TripHistory from './pages/TripHistory';
import SOSHistory from './pages/SOSHistory';
import InspectionHistory from './pages/InspectionHistory';
import InspectionHistoryDetail from './pages/InspectionHistoryDetail';
import ReminderInbox from './pages/ReminderInbox';
import DriverLayout from './components/DriverLayout';

function App() {
  const { t } = useTranslation();
  const { session, loading } = useSupabaseSession();

  const authLoadingFallback = (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'var(--text-tertiary)' }}>
      {t('common.loading')}
    </div>
  );

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: 12,
        background: 'var(--bg-page)',
      }}>
        <div style={{
          width: 48,
          height: 48,
          borderRadius: 14,
          background: 'var(--primary)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: 14,
          fontWeight: 800,
        }}>
          ubus
        </div>
        <div style={{ color: 'var(--text-tertiary)', fontSize: 14 }}>{t('common.loading')}</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={session ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/"
        element={
          <AuthGuard requiredRole="driver" loadingFallback={authLoadingFallback}>
            <DriverLayout />
          </AuthGuard>
        }
      >
        <Route index element={<TodayTasks />} />
        <Route path="my-tasks" element={<TripHistory />} />
        <Route path="task/:id" element={<TaskDetail />} />
        <Route path="inspection" element={<PreTripInspection />} />
        <Route path="profile" element={<Profile />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="sos-history" element={<SOSHistory />} />
        <Route path="reminders" element={<ReminderInbox />} />
        <Route path="inspection-history" element={<InspectionHistory />} />
        <Route path="inspection-history/:id" element={<InspectionHistoryDetail />} />
        <Route path="history" element={<Navigate to="/my-tasks" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
